export default {
	TitleForm: 'Thông báo',
	FromDate: 'Từ ngày',
	ToDate: 'Đến ngày',
	FilterBy: 'Lọc theo',
	PlaceHoderSearch:
		'Nhập mã giao dịch, mã số thuế, trích yếu, lý do, kết quả để tìm kiếm',
	Columns: {
		NotificationNo: 'Số thông báo',
		SubmissionCode: 'Mã giao dịch',
		TypeService: 'Loại dịch vụ',
		NotificationName: 'Tên thông báo',
		ReceivedDate: 'Ngày nhận',
		AgencyNotification: 'Cơ quan thông báo'
	},
	DoesNotHaveNotification: 'Chưa có thông báo.',
	OnlySupportViewXml:
		'Chương trình không hỗ trợ xem thông báo này. Vui lòng tải về.'
};
